import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFApptTimeSlots } from 'utils/types';
import css from './Schedule.css';
import RadioOption from 'common/RadioOption';
import SlotLabel from "./SlotLabel";

export default class SlotsListOptions extends React.Component {

  isChecked(startDate, ownerId) {
    if (!this.props.slotStartDate) {
      return false;
    }
    return startDate.toString() === this.props.slotStartDate.toString() && ownerId === this.props.slotOwnerId;
  }

  render() {
    return (
      <div className={css['radio-container']} data-role='slotsContainer'>
        {this.props.slots.map((appointmentTimeSlot, i) => (
          <RadioOption
            key={i}
            ariaLabel={appointmentTimeSlot.description}
            radioName="slot-radio-form"
            onChange={() => this.props.onSlotSelected(appointmentTimeSlot)}
            label={<SlotLabel slot={appointmentTimeSlot} />}
            isChecked={this.isChecked(appointmentTimeSlot.slotStartDate, appointmentTimeSlot.ownerId)}
          />
        ))}
      </div>
    );
  }
}

SlotsListOptions.propTypes = {
  slots: SFApptTimeSlots.isRequired,
  slotStartDate: PropTypes.object,
  slotOwnerId: SFEntityID,
  onSlotSelected: PropTypes.func.isRequired,
  isService: PropTypes.bool.isRequired,
  currentDuration: PropTypes.number,
  locationName: PropTypes.string
};
